import React from 'react'
import { splitByUnsupportedCharacters } from '../utils/columnNameStandardizer'

const HighlightedColumnName: React.FC<{ name: string }> = ({ name }) => (
    <>
        {splitByUnsupportedCharacters(name).map((segment, index) =>
            segment.unsupported ? (
                <span key={index} className="text-red-600 font-semibold" data-testid="unsupported-char">
                    {segment.text}
                </span>
            ) : (
                <React.Fragment key={index}>{segment.text}</React.Fragment>
            ),
        )}
    </>
)

export default HighlightedColumnName
